import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Modal } from 'semantic-ui-react';
import DocumentCreatedAt from 'scenes/Jobs/components/DocumentCreatedAt';
import DocumentCreatedBy from 'scenes/Jobs/components/DocumentCreatedBy';
import DocumentAssignedUserList from 'scenes/Jobs/components/DocumentAssignedUsersList';
import JobField from '../JobField';
import { selectDocument } from './selectors';
import JobAssessmentScores from '../JobAssessmentScores';

export default function JobAssessmentsSummary(): React.ReactElement | null {
    const document = useSelector(selectDocument);
    if (!document) {
        return null;
    }

    return (
        <React.Fragment>
            <Modal.Header>Assessment Details</Modal.Header>
            <Modal.Content>
                <Grid stackable relaxed style={{ paddingBottom: '25px' }}>
                    <Grid.Column>
                        <JobField
                            label="Date"
                            value={
                                <DocumentCreatedAt documentId={document.id} />
                            }
                        />
                        <JobField
                            label="Created By"
                            value={
                                <DocumentCreatedBy documentId={document.id} />
                            }
                        />
                        <JobField
                            label="Assignees"
                            value={
                                <DocumentAssignedUserList
                                    documentId={document.id}
                                />
                            }
                        />
                        <JobAssessmentScores
                            documentSetId={document.documentSetId}
                        />
                    </Grid.Column>
                </Grid>
            </Modal.Content>
        </React.Fragment>
    );
}
